import React, { Component } from 'react';
import Link, { withPrefix } from 'gatsby-link';
import MobileMenu from './MobileMenu';
import HeaderLink from './HeaderLink';
import HeaderDropdown from './HeaderDropdown';
import logo from '../../assets/img/logo.png';

const Header = ({ location }) => {
    const isHomepage = location.pathname === withPrefix('/');

    return (
        <div>
            <MobileMenu isHomepage={isHomepage} />
            <div className={isHomepage ? 'Header Home' : 'Header'}>
                {!isHomepage && (
                    <HeaderLink
                        to="/"
                        label={<img className="logo" src={logo} />}
                    />
                )}
                <HeaderDropdown>
                    <HeaderLink to="/history" label="History" />
                    <HeaderLink
                        to="/doctrinal-ethical-covenant"
                        label="Doctrinal and Ethical Covenant"
                    />
                    <HeaderLink
                        to="/statement-of-purpose"
                        label="Statement of Purpose"
                    />
                    <HeaderLink
                        to="/board-of-directors"
                        label="Board of Directors"
                    />
                    <HeaderLink to="/ycfc-staff" label="YCFC Staff" />
                </HeaderDropdown>
            </div>
        </div>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js